<div (click)="select()" class="flex-direction-row align-items-center z-index-1 cursor-pointer position-relative">
  <mat-radio-button class="custom-radio-button"
                    [ngClass]="{'choice-delivery-radio-active': isSelected, 'choice-delivery-radio': !isSelected}"
                    [name]="inputName" [checked]="isSelected">
  </mat-radio-button>

  <div class="ccs__container">
    <div class="flex-direction-column">
      <span class="ccs__payment-type">{{ paymentType }}</span>
      <span class="ccs__credit-card">{{ creditCardLast4Numbers }}</span>
    </div>

    <div class="visa-master-card-icons">
      <img src="assets/payment-type/credit-card.svg" alt="Credit Card">
    </div>
  </div>
</div>
